export default __webpack_public_path__ + "static/media/arrow_calendar.1f5846fd.svg";